/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as EditorRouteImport } from './routes/_editor'
import { Route as StoreRouteImport } from './routes/_store'
import { Route as AcceptInviteRouteImport } from './routes/accept-invite'
import { Route as ForgotPasswordRouteImport } from './routes/forgot-password'
import { Route as LoginRouteImport } from './routes/login'
import { Route as PlatformRouteImport } from './routes/platform'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as SupportRouteImport } from './routes/support'
import { Route as StoreIndexRouteImport } from './routes/_store/index'
import { Route as StoreAbandonedCheckoutsRouteImport } from './routes/_store/abandoned-checkouts'
import { Route as StoreBrandsRouteImport } from './routes/_store/brands'
import { Route as StoreCategoriesRouteImport } from './routes/_store/categories'
import { Route as StoreCollectionsRouteImport } from './routes/_store/collections'
import { Route as StoreCustomersRouteImport } from './routes/_store/customers'
import { Route as StoreDiscountsRouteImport } from './routes/_store/discounts'
import { Route as StoreFinanceRouteImport } from './routes/_store/finance'
import { Route as StoreFormSubmissionsRouteImport } from './routes/_store/form-submissions'
import { Route as StoreLeadsRouteImport } from './routes/_store/leads'
import { Route as StoreLocationsRouteImport } from './routes/_store/locations'
import { Route as StoreOrdersRouteImport } from './routes/_store/orders'
import { Route as StorePreordersRouteImport } from './routes/_store/preorders'
import { Route as StoreQuotesRouteImport } from './routes/_store/quotes'
import { Route as StoreReturnsRouteImport } from './routes/_store/returns'
import { Route as StoreReviewsRouteImport } from './routes/_store/reviews'
import { Route as StoreSegmentsRouteImport } from './routes/_store/segments'
import { Route as StoreSettingsRouteImport } from './routes/_store/settings'
import { Route as PlatformIndexRouteImport } from './routes/platform/index'
import { Route as EditorOnlineStoreThemeSettingsRouteImport } from './routes/_editor/online-store/theme-settings'
import { Route as StoreAppsIndexRouteImport } from './routes/_store/apps/index'
import { Route as StoreAppsStatePricingRouteImport } from './routes/_store/apps/state-pricing'
import { Route as StoreCategoriesIdRouteImport } from './routes/_store/categories_.$id'
import { Route as StoreCategoriesBulkEditRouteImport } from './routes/_store/categories_.bulk-edit'
import { Route as StoreCategoriesNewRouteImport } from './routes/_store/categories_.new'
import { Route as StoreCollectionsIdRouteImport } from './routes/_store/collections_.$id'
import { Route as StoreCollectionsBulkEditRouteImport } from './routes/_store/collections_.bulk-edit'
import { Route as StoreCollectionsNewRouteImport } from './routes/_store/collections_.new'
import { Route as StoreCustomersCustomerIdRouteImport } from './routes/_store/customers_.$customerId'
import { Route as StoreDiscountsIdRouteImport } from './routes/_store/discounts_.$id'
import { Route as StoreDiscountsNewRouteImport } from './routes/_store/discounts_.new'
import { Route as StoreFinanceExpensesRouteImport } from './routes/_store/finance_.expenses'
import { Route as StoreFinanceReportsRouteImport } from './routes/_store/finance_.reports'
import { Route as StoreInventoryIndexRouteImport } from './routes/_store/inventory/index'
import { Route as StoreLocationsIdRouteImport } from './routes/_store/locations_.$id'
import { Route as StoreLocationsNewRouteImport } from './routes/_store/locations_.new'
import { Route as StoreOnlineStoreBlogRouteImport } from './routes/_store/online-store/blog'
import { Route as StoreOnlineStoreMediaRouteImport } from './routes/_store/online-store/media'
import { Route as StoreOnlineStoreMenusRouteImport } from './routes/_store/online-store/menus'
import { Route as StoreOnlineStorePagesRouteImport } from './routes/_store/online-store/pages'
import { Route as StoreOnlineStoreThemeRouteImport } from './routes/_store/online-store/theme'
import { Route as StoreOnlineStoreThemeLibraryRouteImport } from './routes/_store/online-store/theme-library'
import { Route as StoreOrdersOrderIdRouteImport } from './routes/_store/orders_.$orderId'
import { Route as StoreOrdersNewRouteImport } from './routes/_store/orders_.new'
import { Route as StoreProductsIndexRouteImport } from './routes/_store/products/index'
import { Route as StoreProductsIdRouteImport } from './routes/_store/products/$id'
import { Route as StoreProductsBulkEditRouteImport } from './routes/_store/products/bulk-edit'
import { Route as StoreProductsNewRouteImport } from './routes/_store/products/new'
import { Route as StoreReturnsReturnIdRouteImport } from './routes/_store/returns_.$returnId'
import { Route as StoreSegmentsSegmentIdRouteImport } from './routes/_store/segments_.$segmentId'
import { Route as StoreSegmentsNewRouteImport } from './routes/_store/segments_.new'
import { Route as StoreSettingsIndexRouteImport } from './routes/_store/settings/index'
import { Route as StoreSettingsActivityRouteImport } from './routes/_store/settings/activity'
import { Route as StoreSettingsAppsRouteImport } from './routes/_store/settings/apps'
import { Route as StoreSettingsBrandingRouteImport } from './routes/_store/settings/branding'
import { Route as StoreSettingsCheckoutRouteImport } from './routes/_store/settings/checkout'
import { Route as StoreSettingsCustomFieldsRouteImport } from './routes/_store/settings/custom-fields'
import { Route as StoreSettingsCustomerAccountsRouteImport } from './routes/_store/settings/customer-accounts'
import { Route as StoreSettingsCustomerPrivacyRouteImport } from './routes/_store/settings/customer-privacy'
import { Route as StoreSettingsDomainsRouteImport } from './routes/_store/settings/domains'
import { Route as StoreSettingsEmailBrandingRouteImport } from './routes/_store/settings/email-branding'
import { Route as StoreSettingsMarketsRouteImport } from './routes/_store/settings/markets'
import { Route as StoreSettingsNotificationAlertsRouteImport } from './routes/_store/settings/notification-alerts'
import { Route as StoreSettingsNotificationsRouteImport } from './routes/_store/settings/notifications'
import { Route as StoreSettingsOrdersRouteImport } from './routes/_store/settings/orders'
import { Route as StoreSettingsPaymentsRouteImport } from './routes/_store/settings/payments'
import { Route as StoreSettingsPlanAndBillingRouteImport } from './routes/_store/settings/plan-and-billing'
import { Route as StoreSettingsPoliciesRouteImport } from './routes/_store/settings/policies'
import { Route as StoreSettingsReturnsRouteImport } from './routes/_store/settings/returns'
import { Route as StoreSettingsShippingRouteImport } from './routes/_store/settings/shipping'
import { Route as StoreSettingsStorageRouteImport } from './routes/_store/settings/storage'
import { Route as StoreSettingsStoreDetailsRouteImport } from './routes/_store/settings/store-details'
import { Route as StoreSettingsStorefrontRouteImport } from './routes/_store/settings/storefront'
import { Route as StoreSettingsSupportRouteImport } from './routes/_store/settings/support'
import { Route as StoreSettingsTaxesRouteImport } from './routes/_store/settings/taxes'
import { Route as StoreSettingsTeamRouteImport } from './routes/_store/settings/team'
import { Route as StoreSettingsUsersRouteImport } from './routes/_store/settings/users'
import { Route as EditorOnlineStoreEditorPageIdRouteImport } from './routes/_editor/online-store/editor/$pageId'
import { Route as StoreOnlineStoreBlogIdRouteImport } from './routes/_store/online-store/blog_.$id'
import { Route as StoreOnlineStoreBlogCategoriesRouteImport } from './routes/_store/online-store/blog_.categories'
import { Route as StoreOnlineStoreBlogNewRouteImport } from './routes/_store/online-store/blog_.new'
import { Route as StoreOnlineStoreMenusHandleRouteImport } from './routes/_store/online-store/menus_.$handle'
import { Route as StoreSettingsMarketsIdRouteImport } from './routes/_store/settings/markets_.$id'

const EditorRoute = EditorRouteImport.update({
  id: '/_editor',
  getParentRoute: () => rootRouteImport,
} as any)
const StoreRoute = StoreRouteImport.update({
  id: '/_store',
  getParentRoute: () => rootRouteImport,
} as any)
const AcceptInviteRoute = AcceptInviteRouteImport.update({
  id: '/accept-invite',
  path: '/accept-invite',
  getParentRoute: () => rootRouteImport,
} as any)
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const PlatformRoute = PlatformRouteImport.update({
  id: '/platform',
  path: '/platform',
  getParentRoute: () => rootRouteImport,
} as any)
const ResetPasswordRoute = ResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => rootRouteImport,
} as any)
const SupportRoute = SupportRouteImport.update({
  id: '/support',
  path: '/support',
  getParentRoute: () => rootRouteImport,
} as any)
const StoreIndexRoute = StoreIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => StoreRoute,
} as any)
const StoreAbandonedCheckoutsRoute = StoreAbandonedCheckoutsRouteImport.update({
  id: '/abandoned-checkouts',
  path: '/abandoned-checkouts',
  getParentRoute: () => StoreRoute,
} as any)
const StoreBrandsRoute = StoreBrandsRouteImport.update({
  id: '/brands',
  path: '/brands',
  getParentRoute: () => StoreRoute,
} as any)
const StoreCategoriesRoute = StoreCategoriesRouteImport.update({
  id: '/categories',
  path: '/categories',
  getParentRoute: () => StoreRoute,
} as any)
const StoreCollectionsRoute = StoreCollectionsRouteImport.update({
  id: '/collections',
  path: '/collections',
  getParentRoute: () => StoreRoute,
} as any)
const StoreCustomersRoute = StoreCustomersRouteImport.update({
  id: '/customers',
  path: '/customers',
  getParentRoute: () => StoreRoute,
} as any)
const StoreDiscountsRoute = StoreDiscountsRouteImport.update({
  id: '/discounts',
  path: '/discounts',
  getParentRoute: () => StoreRoute,
} as any)
const StoreFinanceRoute = StoreFinanceRouteImport.update({
  id: '/finance',
  path: '/finance',
  getParentRoute: () => StoreRoute,
} as any)
const StoreFormSubmissionsRoute = StoreFormSubmissionsRouteImport.update({
  id: '/form-submissions',
  path: '/form-submissions',
  getParentRoute: () => StoreRoute,
} as any)
const StoreLeadsRoute = StoreLeadsRouteImport.update({
  id: '/leads',
  path: '/leads',
  getParentRoute: () => StoreRoute,
} as any)
const StoreLocationsRoute = StoreLocationsRouteImport.update({
  id: '/locations',
  path: '/locations',
  getParentRoute: () => StoreRoute,
} as any)
const StoreOrdersRoute = StoreOrdersRouteImport.update({
  id: '/orders',
  path: '/orders',
  getParentRoute: () => StoreRoute,
} as any)
const StorePreordersRoute = StorePreordersRouteImport.update({
  id: '/preorders',
  path: '/preorders',
  getParentRoute: () => StoreRoute,
} as any)
const StoreQuotesRoute = StoreQuotesRouteImport.update({
  id: '/quotes',
  path: '/quotes',
  getParentRoute: () => StoreRoute,
} as any)
const StoreReturnsRoute = StoreReturnsRouteImport.update({
  id: '/returns',
  path: '/returns',
  getParentRoute: () => StoreRoute,
} as any)
const StoreReviewsRoute = StoreReviewsRouteImport.update({
  id: '/reviews',
  path: '/reviews',
  getParentRoute: () => StoreRoute,
} as any)
const StoreSegmentsRoute = StoreSegmentsRouteImport.update({
  id: '/segments',
  path: '/segments',
  getParentRoute: () => StoreRoute,
} as any)
const StoreSettingsRoute = StoreSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => StoreRoute,
} as any)
const PlatformIndexRoute = PlatformIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => PlatformRoute,
} as any)
const EditorOnlineStoreThemeSettingsRoute =
  EditorOnlineStoreThemeSettingsRouteImport.update({
    id: '/online-store/theme-settings',
    path: '/online-store/theme-settings',
    getParentRoute: () => EditorRoute,
  } as any)
const StoreAppsIndexRoute = StoreAppsIndexRouteImport.update({
  id: '/apps/',
  path: '/apps/',
  getParentRoute: () => StoreRoute,
} as any)
const StoreAppsStatePricingRoute = StoreAppsStatePricingRouteImport.update({
  id: '/apps/state-pricing',
  path: '/apps/state-pricing',
  getParentRoute: () => StoreRoute,
} as any)
const StoreCategoriesIdRoute = StoreCategoriesIdRouteImport.update({
  id: '/categories_/$id',
  path: '/categories/$id',
  getParentRoute: () => StoreRoute,
} as any)
const StoreCategoriesBulkEditRoute = StoreCategoriesBulkEditRouteImport.update({
  id: '/categories_/bulk-edit',
  path: '/categories/bulk-edit',
  getParentRoute: () => StoreRoute,
} as any)
const StoreCategoriesNewRoute = StoreCategoriesNewRouteImport.update({
  id: '/categories_/new',
  path: '/categories/new',
  getParentRoute: () => StoreRoute,
} as any)
const StoreCollectionsIdRoute = StoreCollectionsIdRouteImport.update({
  id: '/collections_/$id',
  path: '/collections/$id',
  getParentRoute: () => StoreRoute,
} as any)
const StoreCollectionsBulkEditRoute =
  StoreCollectionsBulkEditRouteImport.update({
    id: '/collections_/bulk-edit',
    path: '/collections/bulk-edit',
    getParentRoute: () => StoreRoute,
  } as any)
const StoreCollectionsNewRoute = StoreCollectionsNewRouteImport.update({
  id: '/collections_/new',
  path: '/collections/new',
  getParentRoute: () => StoreRoute,
} as any)
const StoreCustomersCustomerIdRoute =
  StoreCustomersCustomerIdRouteImport.update({
    id: '/customers_/$customerId',
    path: '/customers/$customerId',
    getParentRoute: () => StoreRoute,
  } as any)
const StoreDiscountsIdRoute = StoreDiscountsIdRouteImport.update({
  id: '/discounts_/$id',
  path: '/discounts/$id',
  getParentRoute: () => StoreRoute,
} as any)
const StoreDiscountsNewRoute = StoreDiscountsNewRouteImport.update({
  id: '/discounts_/new',
  path: '/discounts/new',
  getParentRoute: () => StoreRoute,
} as any)
const StoreFinanceExpensesRoute = StoreFinanceExpensesRouteImport.update({
  id: '/finance_/expenses',
  path: '/finance/expenses',
  getParentRoute: () => StoreRoute,
} as any)
const StoreFinanceReportsRoute = StoreFinanceReportsRouteImport.update({
  id: '/finance_/reports',
  path: '/finance/reports',
  getParentRoute: () => StoreRoute,
} as any)
const StoreInventoryIndexRoute = StoreInventoryIndexRouteImport.update({
  id: '/inventory/',
  path: '/inventory/',
  getParentRoute: () => StoreRoute,
} as any)
const StoreLocationsIdRoute = StoreLocationsIdRouteImport.update({
  id: '/locations_/$id',
  path: '/locations/$id',
  getParentRoute: () => StoreRoute,
} as any)
const StoreLocationsNewRoute = StoreLocationsNewRouteImport.update({
  id: '/locations_/new',
  path: '/locations/new',
  getParentRoute: () => StoreRoute,
} as any)
const StoreOnlineStoreBlogRoute = StoreOnlineStoreBlogRouteImport.update({
  id: '/online-store/blog',
  path: '/online-store/blog',
  getParentRoute: () => StoreRoute,
} as any)
const StoreOnlineStoreMediaRoute = StoreOnlineStoreMediaRouteImport.update({
  id: '/online-store/media',
  path: '/online-store/media',
  getParentRoute: () => StoreRoute,
} as any)
const StoreOnlineStoreMenusRoute = StoreOnlineStoreMenusRouteImport.update({
  id: '/online-store/menus',
  path: '/online-store/menus',
  getParentRoute: () => StoreRoute,
} as any)
const StoreOnlineStorePagesRoute = StoreOnlineStorePagesRouteImport.update({
  id: '/online-store/pages',
  path: '/online-store/pages',
  getParentRoute: () => StoreRoute,
} as any)
const StoreOnlineStoreThemeRoute = StoreOnlineStoreThemeRouteImport.update({
  id: '/online-store/theme',
  path: '/online-store/theme',
  getParentRoute: () => StoreRoute,
} as any)
const StoreOnlineStoreThemeLibraryRoute =
  StoreOnlineStoreThemeLibraryRouteImport.update({
    id: '/online-store/theme-library',
    path: '/online-store/theme-library',
    getParentRoute: () => StoreRoute,
  } as any)
const StoreOrdersOrderIdRoute = StoreOrdersOrderIdRouteImport.update({
  id: '/orders_/$orderId',
  path: '/orders/$orderId',
  getParentRoute: () => StoreRoute,
} as any)
const StoreOrdersNewRoute = StoreOrdersNewRouteImport.update({
  id: '/orders_/new',
  path: '/orders/new',
  getParentRoute: () => StoreRoute,
} as any)
const StoreProductsIndexRoute = StoreProductsIndexRouteImport.update({
  id: '/products/',
  path: '/products/',
  getParentRoute: () => StoreRoute,
} as any)
const StoreProductsIdRoute = StoreProductsIdRouteImport.update({
  id: '/products/$id',
  path: '/products/$id',
  getParentRoute: () => StoreRoute,
} as any)
const StoreProductsBulkEditRoute = StoreProductsBulkEditRouteImport.update({
  id: '/products/bulk-edit',
  path: '/products/bulk-edit',
  getParentRoute: () => StoreRoute,
} as any)
const StoreProductsNewRoute = StoreProductsNewRouteImport.update({
  id: '/products/new',
  path: '/products/new',
  getParentRoute: () => StoreRoute,
} as any)
const StoreReturnsReturnIdRoute = StoreReturnsReturnIdRouteImport.update({
  id: '/returns_/$returnId',
  path: '/returns/$returnId',
  getParentRoute: () => StoreRoute,
} as any)
const StoreSegmentsSegmentIdRoute = StoreSegmentsSegmentIdRouteImport.update({
  id: '/segments_/$segmentId',
  path: '/segments/$segmentId',
  getParentRoute: () => StoreRoute,
} as any)
const StoreSegmentsNewRoute = StoreSegmentsNewRouteImport.update({
  id: '/segments_/new',
  path: '/segments/new',
  getParentRoute: () => StoreRoute,
} as any)
const StoreSettingsIndexRoute = StoreSettingsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => StoreSettingsRoute,
} as any)
const StoreSettingsActivityRoute = StoreSettingsActivityRouteImport.update({
  id: '/activity',
  path: '/activity',
  getParentRoute: () => StoreSettingsRoute,
} as any)
const StoreSettingsAppsRoute = StoreSettingsAppsRouteImport.update({
  id: '/apps',
  path: '/apps',
  getParentRoute: () => StoreSettingsRoute,
} as any)
const StoreSettingsBrandingRoute = StoreSettingsBrandingRouteImport.update({
  id: '/branding',
  path: '/branding',
  getParentRoute: () => StoreSettingsRoute,
} as any)
const StoreSettingsCheckoutRoute = StoreSettingsCheckoutRouteImport.update({
  id: '/checkout',
  path: '/checkout',
  getParentRoute: () => StoreSettingsRoute,
} as any)
const StoreSettingsCustomFieldsRoute =
  StoreSettingsCustomFieldsRouteImport.update({
    id: '/custom-fields',
    path: '/custom-fields',
    getParentRoute: () => StoreSettingsRoute,
  } as any)
const StoreSettingsCustomerAccountsRoute =
  StoreSettingsCustomerAccountsRouteImport.update({
    id: '/customer-accounts',
    path: '/customer-accounts',
    getParentRoute: () => StoreSettingsRoute,
  } as any)
const StoreSettingsCustomerPrivacyRoute =
  StoreSettingsCustomerPrivacyRouteImport.update({
    id: '/customer-privacy',
    path: '/customer-privacy',
    getParentRoute: () => StoreSettingsRoute,
  } as any)
const StoreSettingsDomainsRoute = StoreSettingsDomainsRouteImport.update({
  id: '/domains',
  path: '/domains',
  getParentRoute: () => StoreSettingsRoute,
} as any)
const StoreSettingsEmailBrandingRoute =
  StoreSettingsEmailBrandingRouteImport.update({
    id: '/email-branding',
    path: '/email-branding',
    getParentRoute: () => StoreSettingsRoute,
  } as any)
const StoreSettingsMarketsRoute = StoreSettingsMarketsRouteImport.update({
  id: '/markets',
  path: '/markets',
  getParentRoute: () => StoreSettingsRoute,
} as any)
const StoreSettingsNotificationAlertsRoute =
  StoreSettingsNotificationAlertsRouteImport.update({
    id: '/notification-alerts',
    path: '/notification-alerts',
    getParentRoute: () => StoreSettingsRoute,
  } as any)
const StoreSettingsNotificationsRoute =
  StoreSettingsNotificationsRouteImport.update({
    id: '/notifications',
    path: '/notifications',
    getParentRoute: () => StoreSettingsRoute,
  } as any)
const StoreSettingsOrdersRoute = StoreSettingsOrdersRouteImport.update({
  id: '/orders',
  path: '/orders',
  getParentRoute: () => StoreSettingsRoute,
} as any)
const StoreSettingsPaymentsRoute = StoreSettingsPaymentsRouteImport.update({
  id: '/payments',
  path: '/payments',
  getParentRoute: () => StoreSettingsRoute,
} as any)
const StoreSettingsPlanAndBillingRoute =
  StoreSettingsPlanAndBillingRouteImport.update({
    id: '/plan-and-billing',
    path: '/plan-and-billing',
    getParentRoute: () => StoreSettingsRoute,
  } as any)
const StoreSettingsPoliciesRoute = StoreSettingsPoliciesRouteImport.update({
  id: '/policies',
  path: '/policies',
  getParentRoute: () => StoreSettingsRoute,
} as any)
const StoreSettingsReturnsRoute = StoreSettingsReturnsRouteImport.update({
  id: '/returns',
  path: '/returns',
  getParentRoute: () => StoreSettingsRoute,
} as any)
const StoreSettingsShippingRoute = StoreSettingsShippingRouteImport.update({
  id: '/shipping',
  path: '/shipping',
  getParentRoute: () => StoreSettingsRoute,
} as any)
const StoreSettingsStorageRoute = StoreSettingsStorageRouteImport.update({
  id: '/storage',
  path: '/storage',
  getParentRoute: () => StoreSettingsRoute,
} as any)
const StoreSettingsStoreDetailsRoute =
  StoreSettingsStoreDetailsRouteImport.update({
    id: '/store-details',
    path: '/store-details',
    getParentRoute: () => StoreSettingsRoute,
  } as any)
const StoreSettingsStorefrontRoute = StoreSettingsStorefrontRouteImport.update({
  id: '/storefront',
  path: '/storefront',
  getParentRoute: () => StoreSettingsRoute,
} as any)
const StoreSettingsSupportRoute = StoreSettingsSupportRouteImport.update({
  id: '/support',
  path: '/support',
  getParentRoute: () => StoreSettingsRoute,
} as any)
const StoreSettingsTaxesRoute = StoreSettingsTaxesRouteImport.update({
  id: '/taxes',
  path: '/taxes',
  getParentRoute: () => StoreSettingsRoute,
} as any)
const StoreSettingsTeamRoute = StoreSettingsTeamRouteImport.update({
  id: '/team',
  path: '/team',
  getParentRoute: () => StoreSettingsRoute,
} as any)
const StoreSettingsUsersRoute = StoreSettingsUsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => StoreSettingsRoute,
} as any)
const EditorOnlineStoreEditorPageIdRoute =
  EditorOnlineStoreEditorPageIdRouteImport.update({
    id: '/online-store/editor/$pageId',
    path: '/online-store/editor/$pageId',
    getParentRoute: () => EditorRoute,
  } as any)
const StoreOnlineStoreBlogIdRoute = StoreOnlineStoreBlogIdRouteImport.update({
  id: '/online-store/blog_/$id',
  path: '/online-store/blog/$id',
  getParentRoute: () => StoreRoute,
} as any)
const StoreOnlineStoreBlogCategoriesRoute =
  StoreOnlineStoreBlogCategoriesRouteImport.update({
    id: '/online-store/blog_/categories',
    path: '/online-store/blog/categories',
    getParentRoute: () => StoreRoute,
  } as any)
const StoreOnlineStoreBlogNewRoute = StoreOnlineStoreBlogNewRouteImport.update({
  id: '/online-store/blog_/new',
  path: '/online-store/blog/new',
  getParentRoute: () => StoreRoute,
} as any)
const StoreOnlineStoreMenusHandleRoute =
  StoreOnlineStoreMenusHandleRouteImport.update({
    id: '/online-store/menus_/$handle',
    path: '/online-store/menus/$handle',
    getParentRoute: () => StoreRoute,
  } as any)
const StoreSettingsMarketsIdRoute = StoreSettingsMarketsIdRouteImport.update({
  id: '/markets_/$id',
  path: '/markets/$id',
  getParentRoute: () => StoreSettingsRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof StoreIndexRoute
  '/accept-invite': typeof AcceptInviteRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/platform': typeof PlatformRouteWithChildren
  '/reset-password': typeof ResetPasswordRoute
  '/support': typeof SupportRoute
  '/abandoned-checkouts': typeof StoreAbandonedCheckoutsRoute
  '/brands': typeof StoreBrandsRoute
  '/categories': typeof StoreCategoriesRoute
  '/collections': typeof StoreCollectionsRoute
  '/customers': typeof StoreCustomersRoute
  '/discounts': typeof StoreDiscountsRoute
  '/finance': typeof StoreFinanceRoute
  '/form-submissions': typeof StoreFormSubmissionsRoute
  '/leads': typeof StoreLeadsRoute
  '/locations': typeof StoreLocationsRoute
  '/orders': typeof StoreOrdersRoute
  '/preorders': typeof StorePreordersRoute
  '/quotes': typeof StoreQuotesRoute
  '/returns': typeof StoreReturnsRoute
  '/reviews': typeof StoreReviewsRoute
  '/segments': typeof StoreSegmentsRoute
  '/settings': typeof StoreSettingsRouteWithChildren
  '/platform/': typeof PlatformIndexRoute
  '/online-store/theme-settings': typeof EditorOnlineStoreThemeSettingsRoute
  '/apps/state-pricing': typeof StoreAppsStatePricingRoute
  '/categories/$id': typeof StoreCategoriesIdRoute
  '/categories/bulk-edit': typeof StoreCategoriesBulkEditRoute
  '/categories/new': typeof StoreCategoriesNewRoute
  '/collections/$id': typeof StoreCollectionsIdRoute
  '/collections/bulk-edit': typeof StoreCollectionsBulkEditRoute
  '/collections/new': typeof StoreCollectionsNewRoute
  '/customers/$customerId': typeof StoreCustomersCustomerIdRoute
  '/discounts/$id': typeof StoreDiscountsIdRoute
  '/discounts/new': typeof StoreDiscountsNewRoute
  '/finance/expenses': typeof StoreFinanceExpensesRoute
  '/finance/reports': typeof StoreFinanceReportsRoute
  '/locations/$id': typeof StoreLocationsIdRoute
  '/locations/new': typeof StoreLocationsNewRoute
  '/online-store/blog': typeof StoreOnlineStoreBlogRoute
  '/online-store/media': typeof StoreOnlineStoreMediaRoute
  '/online-store/menus': typeof StoreOnlineStoreMenusRoute
  '/online-store/pages': typeof StoreOnlineStorePagesRoute
  '/online-store/theme': typeof StoreOnlineStoreThemeRoute
  '/online-store/theme-library': typeof StoreOnlineStoreThemeLibraryRoute
  '/orders/$orderId': typeof StoreOrdersOrderIdRoute
  '/orders/new': typeof StoreOrdersNewRoute
  '/products/$id': typeof StoreProductsIdRoute
  '/products/bulk-edit': typeof StoreProductsBulkEditRoute
  '/products/new': typeof StoreProductsNewRoute
  '/returns/$returnId': typeof StoreReturnsReturnIdRoute
  '/segments/$segmentId': typeof StoreSegmentsSegmentIdRoute
  '/segments/new': typeof StoreSegmentsNewRoute
  '/settings/activity': typeof StoreSettingsActivityRoute
  '/settings/apps': typeof StoreSettingsAppsRoute
  '/settings/branding': typeof StoreSettingsBrandingRoute
  '/settings/checkout': typeof StoreSettingsCheckoutRoute
  '/settings/custom-fields': typeof StoreSettingsCustomFieldsRoute
  '/settings/customer-accounts': typeof StoreSettingsCustomerAccountsRoute
  '/settings/customer-privacy': typeof StoreSettingsCustomerPrivacyRoute
  '/settings/domains': typeof StoreSettingsDomainsRoute
  '/settings/email-branding': typeof StoreSettingsEmailBrandingRoute
  '/settings/markets': typeof StoreSettingsMarketsRoute
  '/settings/notification-alerts': typeof StoreSettingsNotificationAlertsRoute
  '/settings/notifications': typeof StoreSettingsNotificationsRoute
  '/settings/orders': typeof StoreSettingsOrdersRoute
  '/settings/payments': typeof StoreSettingsPaymentsRoute
  '/settings/plan-and-billing': typeof StoreSettingsPlanAndBillingRoute
  '/settings/policies': typeof StoreSettingsPoliciesRoute
  '/settings/returns': typeof StoreSettingsReturnsRoute
  '/settings/shipping': typeof StoreSettingsShippingRoute
  '/settings/storage': typeof StoreSettingsStorageRoute
  '/settings/store-details': typeof StoreSettingsStoreDetailsRoute
  '/settings/storefront': typeof StoreSettingsStorefrontRoute
  '/settings/support': typeof StoreSettingsSupportRoute
  '/settings/taxes': typeof StoreSettingsTaxesRoute
  '/settings/team': typeof StoreSettingsTeamRoute
  '/settings/users': typeof StoreSettingsUsersRoute
  '/apps/': typeof StoreAppsIndexRoute
  '/inventory/': typeof StoreInventoryIndexRoute
  '/products/': typeof StoreProductsIndexRoute
  '/settings/': typeof StoreSettingsIndexRoute
  '/online-store/editor/$pageId': typeof EditorOnlineStoreEditorPageIdRoute
  '/online-store/blog/$id': typeof StoreOnlineStoreBlogIdRoute
  '/online-store/blog/categories': typeof StoreOnlineStoreBlogCategoriesRoute
  '/online-store/blog/new': typeof StoreOnlineStoreBlogNewRoute
  '/online-store/menus/$handle': typeof StoreOnlineStoreMenusHandleRoute
  '/settings/markets/$id': typeof StoreSettingsMarketsIdRoute
}
export interface FileRoutesByTo {
  '/': typeof StoreIndexRoute
  '/accept-invite': typeof AcceptInviteRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/reset-password': typeof ResetPasswordRoute
  '/support': typeof SupportRoute
  '/abandoned-checkouts': typeof StoreAbandonedCheckoutsRoute
  '/brands': typeof StoreBrandsRoute
  '/categories': typeof StoreCategoriesRoute
  '/collections': typeof StoreCollectionsRoute
  '/customers': typeof StoreCustomersRoute
  '/discounts': typeof StoreDiscountsRoute
  '/finance': typeof StoreFinanceRoute
  '/form-submissions': typeof StoreFormSubmissionsRoute
  '/leads': typeof StoreLeadsRoute
  '/locations': typeof StoreLocationsRoute
  '/orders': typeof StoreOrdersRoute
  '/preorders': typeof StorePreordersRoute
  '/quotes': typeof StoreQuotesRoute
  '/returns': typeof StoreReturnsRoute
  '/reviews': typeof StoreReviewsRoute
  '/segments': typeof StoreSegmentsRoute
  '/platform': typeof PlatformIndexRoute
  '/online-store/theme-settings': typeof EditorOnlineStoreThemeSettingsRoute
  '/apps/state-pricing': typeof StoreAppsStatePricingRoute
  '/categories/$id': typeof StoreCategoriesIdRoute
  '/categories/bulk-edit': typeof StoreCategoriesBulkEditRoute
  '/categories/new': typeof StoreCategoriesNewRoute
  '/collections/$id': typeof StoreCollectionsIdRoute
  '/collections/bulk-edit': typeof StoreCollectionsBulkEditRoute
  '/collections/new': typeof StoreCollectionsNewRoute
  '/customers/$customerId': typeof StoreCustomersCustomerIdRoute
  '/discounts/$id': typeof StoreDiscountsIdRoute
  '/discounts/new': typeof StoreDiscountsNewRoute
  '/finance/expenses': typeof StoreFinanceExpensesRoute
  '/finance/reports': typeof StoreFinanceReportsRoute
  '/locations/$id': typeof StoreLocationsIdRoute
  '/locations/new': typeof StoreLocationsNewRoute
  '/online-store/blog': typeof StoreOnlineStoreBlogRoute
  '/online-store/media': typeof StoreOnlineStoreMediaRoute
  '/online-store/menus': typeof StoreOnlineStoreMenusRoute
  '/online-store/pages': typeof StoreOnlineStorePagesRoute
  '/online-store/theme': typeof StoreOnlineStoreThemeRoute
  '/online-store/theme-library': typeof StoreOnlineStoreThemeLibraryRoute
  '/orders/$orderId': typeof StoreOrdersOrderIdRoute
  '/orders/new': typeof StoreOrdersNewRoute
  '/products/$id': typeof StoreProductsIdRoute
  '/products/bulk-edit': typeof StoreProductsBulkEditRoute
  '/products/new': typeof StoreProductsNewRoute
  '/returns/$returnId': typeof StoreReturnsReturnIdRoute
  '/segments/$segmentId': typeof StoreSegmentsSegmentIdRoute
  '/segments/new': typeof StoreSegmentsNewRoute
  '/settings/activity': typeof StoreSettingsActivityRoute
  '/settings/apps': typeof StoreSettingsAppsRoute
  '/settings/branding': typeof StoreSettingsBrandingRoute
  '/settings/checkout': typeof StoreSettingsCheckoutRoute
  '/settings/custom-fields': typeof StoreSettingsCustomFieldsRoute
  '/settings/customer-accounts': typeof StoreSettingsCustomerAccountsRoute
  '/settings/customer-privacy': typeof StoreSettingsCustomerPrivacyRoute
  '/settings/domains': typeof StoreSettingsDomainsRoute
  '/settings/email-branding': typeof StoreSettingsEmailBrandingRoute
  '/settings/markets': typeof StoreSettingsMarketsRoute
  '/settings/notification-alerts': typeof StoreSettingsNotificationAlertsRoute
  '/settings/notifications': typeof StoreSettingsNotificationsRoute
  '/settings/orders': typeof StoreSettingsOrdersRoute
  '/settings/payments': typeof StoreSettingsPaymentsRoute
  '/settings/plan-and-billing': typeof StoreSettingsPlanAndBillingRoute
  '/settings/policies': typeof StoreSettingsPoliciesRoute
  '/settings/returns': typeof StoreSettingsReturnsRoute
  '/settings/shipping': typeof StoreSettingsShippingRoute
  '/settings/storage': typeof StoreSettingsStorageRoute
  '/settings/store-details': typeof StoreSettingsStoreDetailsRoute
  '/settings/storefront': typeof StoreSettingsStorefrontRoute
  '/settings/support': typeof StoreSettingsSupportRoute
  '/settings/taxes': typeof StoreSettingsTaxesRoute
  '/settings/team': typeof StoreSettingsTeamRoute
  '/settings/users': typeof StoreSettingsUsersRoute
  '/apps': typeof StoreAppsIndexRoute
  '/inventory': typeof StoreInventoryIndexRoute
  '/products': typeof StoreProductsIndexRoute
  '/settings': typeof StoreSettingsIndexRoute
  '/online-store/editor/$pageId': typeof EditorOnlineStoreEditorPageIdRoute
  '/online-store/blog/$id': typeof StoreOnlineStoreBlogIdRoute
  '/online-store/blog/categories': typeof StoreOnlineStoreBlogCategoriesRoute
  '/online-store/blog/new': typeof StoreOnlineStoreBlogNewRoute
  '/online-store/menus/$handle': typeof StoreOnlineStoreMenusHandleRoute
  '/settings/markets/$id': typeof StoreSettingsMarketsIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_editor': typeof EditorRouteWithChildren
  '/_store': typeof StoreRouteWithChildren
  '/accept-invite': typeof AcceptInviteRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/platform': typeof PlatformRouteWithChildren
  '/reset-password': typeof ResetPasswordRoute
  '/support': typeof SupportRoute
  '/_store/abandoned-checkouts': typeof StoreAbandonedCheckoutsRoute
  '/_store/brands': typeof StoreBrandsRoute
  '/_store/categories': typeof StoreCategoriesRoute
  '/_store/collections': typeof StoreCollectionsRoute
  '/_store/customers': typeof StoreCustomersRoute
  '/_store/discounts': typeof StoreDiscountsRoute
  '/_store/finance': typeof StoreFinanceRoute
  '/_store/form-submissions': typeof StoreFormSubmissionsRoute
  '/_store/leads': typeof StoreLeadsRoute
  '/_store/locations': typeof StoreLocationsRoute
  '/_store/orders': typeof StoreOrdersRoute
  '/_store/preorders': typeof StorePreordersRoute
  '/_store/quotes': typeof StoreQuotesRoute
  '/_store/returns': typeof StoreReturnsRoute
  '/_store/reviews': typeof StoreReviewsRoute
  '/_store/segments': typeof StoreSegmentsRoute
  '/_store/settings': typeof StoreSettingsRouteWithChildren
  '/_store/': typeof StoreIndexRoute
  '/platform/': typeof PlatformIndexRoute
  '/_editor/online-store/theme-settings': typeof EditorOnlineStoreThemeSettingsRoute
  '/_store/apps/state-pricing': typeof StoreAppsStatePricingRoute
  '/_store/categories_/$id': typeof StoreCategoriesIdRoute
  '/_store/categories_/bulk-edit': typeof StoreCategoriesBulkEditRoute
  '/_store/categories_/new': typeof StoreCategoriesNewRoute
  '/_store/collections_/$id': typeof StoreCollectionsIdRoute
  '/_store/collections_/bulk-edit': typeof StoreCollectionsBulkEditRoute
  '/_store/collections_/new': typeof StoreCollectionsNewRoute
  '/_store/customers_/$customerId': typeof StoreCustomersCustomerIdRoute
  '/_store/discounts_/$id': typeof StoreDiscountsIdRoute
  '/_store/discounts_/new': typeof StoreDiscountsNewRoute
  '/_store/finance_/expenses': typeof StoreFinanceExpensesRoute
  '/_store/finance_/reports': typeof StoreFinanceReportsRoute
  '/_store/locations_/$id': typeof StoreLocationsIdRoute
  '/_store/locations_/new': typeof StoreLocationsNewRoute
  '/_store/online-store/blog': typeof StoreOnlineStoreBlogRoute
  '/_store/online-store/media': typeof StoreOnlineStoreMediaRoute
  '/_store/online-store/menus': typeof StoreOnlineStoreMenusRoute
  '/_store/online-store/pages': typeof StoreOnlineStorePagesRoute
  '/_store/online-store/theme': typeof StoreOnlineStoreThemeRoute
  '/_store/online-store/theme-library': typeof StoreOnlineStoreThemeLibraryRoute
  '/_store/orders_/$orderId': typeof StoreOrdersOrderIdRoute
  '/_store/orders_/new': typeof StoreOrdersNewRoute
  '/_store/products/$id': typeof StoreProductsIdRoute
  '/_store/products/bulk-edit': typeof StoreProductsBulkEditRoute
  '/_store/products/new': typeof StoreProductsNewRoute
  '/_store/returns_/$returnId': typeof StoreReturnsReturnIdRoute
  '/_store/segments_/$segmentId': typeof StoreSegmentsSegmentIdRoute
  '/_store/segments_/new': typeof StoreSegmentsNewRoute
  '/_store/settings/activity': typeof StoreSettingsActivityRoute
  '/_store/settings/apps': typeof StoreSettingsAppsRoute
  '/_store/settings/branding': typeof StoreSettingsBrandingRoute
  '/_store/settings/checkout': typeof StoreSettingsCheckoutRoute
  '/_store/settings/custom-fields': typeof StoreSettingsCustomFieldsRoute
  '/_store/settings/customer-accounts': typeof StoreSettingsCustomerAccountsRoute
  '/_store/settings/customer-privacy': typeof StoreSettingsCustomerPrivacyRoute
  '/_store/settings/domains': typeof StoreSettingsDomainsRoute
  '/_store/settings/email-branding': typeof StoreSettingsEmailBrandingRoute
  '/_store/settings/markets': typeof StoreSettingsMarketsRoute
  '/_store/settings/notification-alerts': typeof StoreSettingsNotificationAlertsRoute
  '/_store/settings/notifications': typeof StoreSettingsNotificationsRoute
  '/_store/settings/orders': typeof StoreSettingsOrdersRoute
  '/_store/settings/payments': typeof StoreSettingsPaymentsRoute
  '/_store/settings/plan-and-billing': typeof StoreSettingsPlanAndBillingRoute
  '/_store/settings/policies': typeof StoreSettingsPoliciesRoute
  '/_store/settings/returns': typeof StoreSettingsReturnsRoute
  '/_store/settings/shipping': typeof StoreSettingsShippingRoute
  '/_store/settings/storage': typeof StoreSettingsStorageRoute
  '/_store/settings/store-details': typeof StoreSettingsStoreDetailsRoute
  '/_store/settings/storefront': typeof StoreSettingsStorefrontRoute
  '/_store/settings/support': typeof StoreSettingsSupportRoute
  '/_store/settings/taxes': typeof StoreSettingsTaxesRoute
  '/_store/settings/team': typeof StoreSettingsTeamRoute
  '/_store/settings/users': typeof StoreSettingsUsersRoute
  '/_store/apps/': typeof StoreAppsIndexRoute
  '/_store/inventory/': typeof StoreInventoryIndexRoute
  '/_store/products/': typeof StoreProductsIndexRoute
  '/_store/settings/': typeof StoreSettingsIndexRoute
  '/_editor/online-store/editor/$pageId': typeof EditorOnlineStoreEditorPageIdRoute
  '/_store/online-store/blog_/$id': typeof StoreOnlineStoreBlogIdRoute
  '/_store/online-store/blog_/categories': typeof StoreOnlineStoreBlogCategoriesRoute
  '/_store/online-store/blog_/new': typeof StoreOnlineStoreBlogNewRoute
  '/_store/online-store/menus_/$handle': typeof StoreOnlineStoreMenusHandleRoute
  '/_store/settings/markets_/$id': typeof StoreSettingsMarketsIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/accept-invite'
    | '/forgot-password'
    | '/login'
    | '/platform'
    | '/reset-password'
    | '/support'
    | '/abandoned-checkouts'
    | '/brands'
    | '/categories'
    | '/collections'
    | '/customers'
    | '/discounts'
    | '/finance'
    | '/form-submissions'
    | '/leads'
    | '/locations'
    | '/orders'
    | '/preorders'
    | '/quotes'
    | '/returns'
    | '/reviews'
    | '/segments'
    | '/settings'
    | '/platform/'
    | '/online-store/theme-settings'
    | '/apps/state-pricing'
    | '/categories/$id'
    | '/categories/bulk-edit'
    | '/categories/new'
    | '/collections/$id'
    | '/collections/bulk-edit'
    | '/collections/new'
    | '/customers/$customerId'
    | '/discounts/$id'
    | '/discounts/new'
    | '/finance/expenses'
    | '/finance/reports'
    | '/locations/$id'
    | '/locations/new'
    | '/online-store/blog'
    | '/online-store/media'
    | '/online-store/menus'
    | '/online-store/pages'
    | '/online-store/theme'
    | '/online-store/theme-library'
    | '/orders/$orderId'
    | '/orders/new'
    | '/products/$id'
    | '/products/bulk-edit'
    | '/products/new'
    | '/returns/$returnId'
    | '/segments/$segmentId'
    | '/segments/new'
    | '/settings/activity'
    | '/settings/apps'
    | '/settings/branding'
    | '/settings/checkout'
    | '/settings/custom-fields'
    | '/settings/customer-accounts'
    | '/settings/customer-privacy'
    | '/settings/domains'
    | '/settings/email-branding'
    | '/settings/markets'
    | '/settings/notification-alerts'
    | '/settings/notifications'
    | '/settings/orders'
    | '/settings/payments'
    | '/settings/plan-and-billing'
    | '/settings/policies'
    | '/settings/returns'
    | '/settings/shipping'
    | '/settings/storage'
    | '/settings/store-details'
    | '/settings/storefront'
    | '/settings/support'
    | '/settings/taxes'
    | '/settings/team'
    | '/settings/users'
    | '/apps/'
    | '/inventory/'
    | '/products/'
    | '/settings/'
    | '/online-store/editor/$pageId'
    | '/online-store/blog/$id'
    | '/online-store/blog/categories'
    | '/online-store/blog/new'
    | '/online-store/menus/$handle'
    | '/settings/markets/$id'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/accept-invite'
    | '/forgot-password'
    | '/login'
    | '/reset-password'
    | '/support'
    | '/abandoned-checkouts'
    | '/brands'
    | '/categories'
    | '/collections'
    | '/customers'
    | '/discounts'
    | '/finance'
    | '/form-submissions'
    | '/leads'
    | '/locations'
    | '/orders'
    | '/preorders'
    | '/quotes'
    | '/returns'
    | '/reviews'
    | '/segments'
    | '/platform'
    | '/online-store/theme-settings'
    | '/apps/state-pricing'
    | '/categories/$id'
    | '/categories/bulk-edit'
    | '/categories/new'
    | '/collections/$id'
    | '/collections/bulk-edit'
    | '/collections/new'
    | '/customers/$customerId'
    | '/discounts/$id'
    | '/discounts/new'
    | '/finance/expenses'
    | '/finance/reports'
    | '/locations/$id'
    | '/locations/new'
    | '/online-store/blog'
    | '/online-store/media'
    | '/online-store/menus'
    | '/online-store/pages'
    | '/online-store/theme'
    | '/online-store/theme-library'
    | '/orders/$orderId'
    | '/orders/new'
    | '/products/$id'
    | '/products/bulk-edit'
    | '/products/new'
    | '/returns/$returnId'
    | '/segments/$segmentId'
    | '/segments/new'
    | '/settings/activity'
    | '/settings/apps'
    | '/settings/branding'
    | '/settings/checkout'
    | '/settings/custom-fields'
    | '/settings/customer-accounts'
    | '/settings/customer-privacy'
    | '/settings/domains'
    | '/settings/email-branding'
    | '/settings/markets'
    | '/settings/notification-alerts'
    | '/settings/notifications'
    | '/settings/orders'
    | '/settings/payments'
    | '/settings/plan-and-billing'
    | '/settings/policies'
    | '/settings/returns'
    | '/settings/shipping'
    | '/settings/storage'
    | '/settings/store-details'
    | '/settings/storefront'
    | '/settings/support'
    | '/settings/taxes'
    | '/settings/team'
    | '/settings/users'
    | '/apps'
    | '/inventory'
    | '/products'
    | '/settings'
    | '/online-store/editor/$pageId'
    | '/online-store/blog/$id'
    | '/online-store/blog/categories'
    | '/online-store/blog/new'
    | '/online-store/menus/$handle'
    | '/settings/markets/$id'
  id:
    | '__root__'
    | '/_editor'
    | '/_store'
    | '/accept-invite'
    | '/forgot-password'
    | '/login'
    | '/platform'
    | '/reset-password'
    | '/support'
    | '/_store/abandoned-checkouts'
    | '/_store/brands'
    | '/_store/categories'
    | '/_store/collections'
    | '/_store/customers'
    | '/_store/discounts'
    | '/_store/finance'
    | '/_store/form-submissions'
    | '/_store/leads'
    | '/_store/locations'
    | '/_store/orders'
    | '/_store/preorders'
    | '/_store/quotes'
    | '/_store/returns'
    | '/_store/reviews'
    | '/_store/segments'
    | '/_store/settings'
    | '/_store/'
    | '/platform/'
    | '/_editor/online-store/theme-settings'
    | '/_store/apps/state-pricing'
    | '/_store/categories_/$id'
    | '/_store/categories_/bulk-edit'
    | '/_store/categories_/new'
    | '/_store/collections_/$id'
    | '/_store/collections_/bulk-edit'
    | '/_store/collections_/new'
    | '/_store/customers_/$customerId'
    | '/_store/discounts_/$id'
    | '/_store/discounts_/new'
    | '/_store/finance_/expenses'
    | '/_store/finance_/reports'
    | '/_store/locations_/$id'
    | '/_store/locations_/new'
    | '/_store/online-store/blog'
    | '/_store/online-store/media'
    | '/_store/online-store/menus'
    | '/_store/online-store/pages'
    | '/_store/online-store/theme'
    | '/_store/online-store/theme-library'
    | '/_store/orders_/$orderId'
    | '/_store/orders_/new'
    | '/_store/products/$id'
    | '/_store/products/bulk-edit'
    | '/_store/products/new'
    | '/_store/returns_/$returnId'
    | '/_store/segments_/$segmentId'
    | '/_store/segments_/new'
    | '/_store/settings/activity'
    | '/_store/settings/apps'
    | '/_store/settings/branding'
    | '/_store/settings/checkout'
    | '/_store/settings/custom-fields'
    | '/_store/settings/customer-accounts'
    | '/_store/settings/customer-privacy'
    | '/_store/settings/domains'
    | '/_store/settings/email-branding'
    | '/_store/settings/markets'
    | '/_store/settings/notification-alerts'
    | '/_store/settings/notifications'
    | '/_store/settings/orders'
    | '/_store/settings/payments'
    | '/_store/settings/plan-and-billing'
    | '/_store/settings/policies'
    | '/_store/settings/returns'
    | '/_store/settings/shipping'
    | '/_store/settings/storage'
    | '/_store/settings/store-details'
    | '/_store/settings/storefront'
    | '/_store/settings/support'
    | '/_store/settings/taxes'
    | '/_store/settings/team'
    | '/_store/settings/users'
    | '/_store/apps/'
    | '/_store/inventory/'
    | '/_store/products/'
    | '/_store/settings/'
    | '/_editor/online-store/editor/$pageId'
    | '/_store/online-store/blog_/$id'
    | '/_store/online-store/blog_/categories'
    | '/_store/online-store/blog_/new'
    | '/_store/online-store/menus_/$handle'
    | '/_store/settings/markets_/$id'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  EditorRoute: typeof EditorRouteWithChildren
  StoreRoute: typeof StoreRouteWithChildren
  AcceptInviteRoute: typeof AcceptInviteRoute
  ForgotPasswordRoute: typeof ForgotPasswordRoute
  LoginRoute: typeof LoginRoute
  PlatformRoute: typeof PlatformRouteWithChildren
  ResetPasswordRoute: typeof ResetPasswordRoute
  SupportRoute: typeof SupportRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_editor': {
      id: '/_editor'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof EditorRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_store': {
      id: '/_store'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof StoreRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/accept-invite': {
      id: '/accept-invite'
      path: '/accept-invite'
      fullPath: '/accept-invite'
      preLoaderRoute: typeof AcceptInviteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/forgot-password': {
      id: '/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof ForgotPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/platform': {
      id: '/platform'
      path: '/platform'
      fullPath: '/platform'
      preLoaderRoute: typeof PlatformRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reset-password': {
      id: '/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof ResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/support': {
      id: '/support'
      path: '/support'
      fullPath: '/support'
      preLoaderRoute: typeof SupportRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_store/': {
      id: '/_store/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof StoreIndexRouteImport
      parentRoute: typeof StoreRoute
    }
    '/_store/abandoned-checkouts': {
      id: '/_store/abandoned-checkouts'
      path: '/abandoned-checkouts'
      fullPath: '/abandoned-checkouts'
      preLoaderRoute: typeof StoreAbandonedCheckoutsRouteImport
      parentRoute: typeof StoreRoute
    }
    '/_store/brands': {
      id: '/_store/brands'
      path: '/brands'
      fullPath: '/brands'
      preLoaderRoute: typeof StoreBrandsRouteImport
      parentRoute: typeof StoreRoute
    }
    '/_store/categories': {
      id: '/_store/categories'
      path: '/categories'
      fullPath: '/categories'
      preLoaderRoute: typeof StoreCategoriesRouteImport
      parentRoute: typeof StoreRoute
    }
    '/_store/collections': {
      id: '/_store/collections'
      path: '/collections'
      fullPath: '/collections'
      preLoaderRoute: typeof StoreCollectionsRouteImport
      parentRoute: typeof StoreRoute
    }
    '/_store/customers': {
      id: '/_store/customers'
      path: '/customers'
      fullPath: '/customers'
      preLoaderRoute: typeof StoreCustomersRouteImport
      parentRoute: typeof StoreRoute
    }
    '/_store/discounts': {
      id: '/_store/discounts'
      path: '/discounts'
      fullPath: '/discounts'
      preLoaderRoute: typeof StoreDiscountsRouteImport
      parentRoute: typeof StoreRoute
    }
    '/_store/finance': {
      id: '/_store/finance'
      path: '/finance'
      fullPath: '/finance'
      preLoaderRoute: typeof StoreFinanceRouteImport
      parentRoute: typeof StoreRoute
    }
    '/_store/form-submissions': {
      id: '/_store/form-submissions'
      path: '/form-submissions'
      fullPath: '/form-submissions'
      preLoaderRoute: typeof StoreFormSubmissionsRouteImport
      parentRoute: typeof StoreRoute
    }
    '/_store/leads': {
      id: '/_store/leads'
      path: '/leads'
      fullPath: '/leads'
      preLoaderRoute: typeof StoreLeadsRouteImport
      parentRoute: typeof StoreRoute
    }
    '/_store/locations': {
      id: '/_store/locations'
      path: '/locations'
      fullPath: '/locations'
      preLoaderRoute: typeof StoreLocationsRouteImport
      parentRoute: typeof StoreRoute
    }
    '/_store/orders': {
      id: '/_store/orders'
      path: '/orders'
      fullPath: '/orders'
      preLoaderRoute: typeof StoreOrdersRouteImport
      parentRoute: typeof StoreRoute
    }
    '/_store/preorders': {
      id: '/_store/preorders'
      path: '/preorders'
      fullPath: '/preorders'
      preLoaderRoute: typeof StorePreordersRouteImport
      parentRoute: typeof StoreRoute
    }
    '/_store/quotes': {
      id: '/_store/quotes'
      path: '/quotes'
      fullPath: '/quotes'
      preLoaderRoute: typeof StoreQuotesRouteImport
      parentRoute: typeof StoreRoute
    }
    '/_store/returns': {
      id: '/_store/returns'
      path: '/returns'
      fullPath: '/returns'
      preLoaderRoute: typeof StoreReturnsRouteImport
      parentRoute: typeof StoreRoute
    }
    '/_store/reviews': {
      id: '/_store/reviews'
      path: '/reviews'
      fullPath: '/reviews'
      preLoaderRoute: typeof StoreReviewsRouteImport
      parentRoute: typeof StoreRoute
    }
    '/_store/segments': {
      id: '/_store/segments'
      path: '/segments'
      fullPath: '/segments'
      preLoaderRoute: typeof StoreSegmentsRouteImport
      parentRoute: typeof StoreRoute
    }
    '/_store/settings': {
      id: '/_store/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof StoreSettingsRouteImport
      parentRoute: typeof StoreRoute
    }
    '/platform/': {
      id: '/platform/'
      path: '/'
      fullPath: '/platform/'
      preLoaderRoute: typeof PlatformIndexRouteImport
      parentRoute: typeof PlatformRoute
    }
    '/_editor/online-store/theme-settings': {
      id: '/_editor/online-store/theme-settings'
      path: '/online-store/theme-settings'
      fullPath: '/online-store/theme-settings'
      preLoaderRoute: typeof EditorOnlineStoreThemeSettingsRouteImport
      parentRoute: typeof EditorRoute
    }
    '/_store/apps/': {
      id: '/_store/apps/'
      path: '/apps'
      fullPath: '/apps/'
      preLoaderRoute: typeof StoreAppsIndexRouteImport
      parentRoute: typeof StoreRoute
    }
    '/_store/apps/state-pricing': {
      id: '/_store/apps/state-pricing'
      path: '/apps/state-pricing'
      fullPath: '/apps/state-pricing'
      preLoaderRoute: typeof StoreAppsStatePricingRouteImport
      parentRoute: typeof StoreRoute
    }
    '/_store/categories_/$id': {
      id: '/_store/categories_/$id'
      path: '/categories/$id'
      fullPath: '/categories/$id'
      preLoaderRoute: typeof StoreCategoriesIdRouteImport
      parentRoute: typeof StoreRoute
    }
    '/_store/categories_/bulk-edit': {
      id: '/_store/categories_/bulk-edit'
      path: '/categories/bulk-edit'
      fullPath: '/categories/bulk-edit'
      preLoaderRoute: typeof StoreCategoriesBulkEditRouteImport
      parentRoute: typeof StoreRoute
    }
    '/_store/categories_/new': {
      id: '/_store/categories_/new'
      path: '/categories/new'
      fullPath: '/categories/new'
      preLoaderRoute: typeof StoreCategoriesNewRouteImport
      parentRoute: typeof StoreRoute
    }
    '/_store/collections_/$id': {
      id: '/_store/collections_/$id'
      path: '/collections/$id'
      fullPath: '/collections/$id'
      preLoaderRoute: typeof StoreCollectionsIdRouteImport
      parentRoute: typeof StoreRoute
    }
    '/_store/collections_/bulk-edit': {
      id: '/_store/collections_/bulk-edit'
      path: '/collections/bulk-edit'
      fullPath: '/collections/bulk-edit'
      preLoaderRoute: typeof StoreCollectionsBulkEditRouteImport
      parentRoute: typeof StoreRoute
    }
    '/_store/collections_/new': {
      id: '/_store/collections_/new'
      path: '/collections/new'
      fullPath: '/collections/new'
      preLoaderRoute: typeof StoreCollectionsNewRouteImport
      parentRoute: typeof StoreRoute
    }
    '/_store/customers_/$customerId': {
      id: '/_store/customers_/$customerId'
      path: '/customers/$customerId'
      fullPath: '/customers/$customerId'
      preLoaderRoute: typeof StoreCustomersCustomerIdRouteImport
      parentRoute: typeof StoreRoute
    }
    '/_store/discounts_/$id': {
      id: '/_store/discounts_/$id'
      path: '/discounts/$id'
      fullPath: '/discounts/$id'
      preLoaderRoute: typeof StoreDiscountsIdRouteImport
      parentRoute: typeof StoreRoute
    }
    '/_store/discounts_/new': {
      id: '/_store/discounts_/new'
      path: '/discounts/new'
      fullPath: '/discounts/new'
      preLoaderRoute: typeof StoreDiscountsNewRouteImport
      parentRoute: typeof StoreRoute
    }
    '/_store/finance_/expenses': {
      id: '/_store/finance_/expenses'
      path: '/finance/expenses'
      fullPath: '/finance/expenses'
      preLoaderRoute: typeof StoreFinanceExpensesRouteImport
      parentRoute: typeof StoreRoute
    }
    '/_store/finance_/reports': {
      id: '/_store/finance_/reports'
      path: '/finance/reports'
      fullPath: '/finance/reports'
      preLoaderRoute: typeof StoreFinanceReportsRouteImport
      parentRoute: typeof StoreRoute
    }
    '/_store/inventory/': {
      id: '/_store/inventory/'
      path: '/inventory'
      fullPath: '/inventory/'
      preLoaderRoute: typeof StoreInventoryIndexRouteImport
      parentRoute: typeof StoreRoute
    }
    '/_store/locations_/$id': {
      id: '/_store/locations_/$id'
      path: '/locations/$id'
      fullPath: '/locations/$id'
      preLoaderRoute: typeof StoreLocationsIdRouteImport
      parentRoute: typeof StoreRoute
    }
    '/_store/locations_/new': {
      id: '/_store/locations_/new'
      path: '/locations/new'
      fullPath: '/locations/new'
      preLoaderRoute: typeof StoreLocationsNewRouteImport
      parentRoute: typeof StoreRoute
    }
    '/_store/online-store/blog': {
      id: '/_store/online-store/blog'
      path: '/online-store/blog'
      fullPath: '/online-store/blog'
      preLoaderRoute: typeof StoreOnlineStoreBlogRouteImport
      parentRoute: typeof StoreRoute
    }
    '/_store/online-store/media': {
      id: '/_store/online-store/media'
      path: '/online-store/media'
      fullPath: '/online-store/media'
      preLoaderRoute: typeof StoreOnlineStoreMediaRouteImport
      parentRoute: typeof StoreRoute
    }
    '/_store/online-store/menus': {
      id: '/_store/online-store/menus'
      path: '/online-store/menus'
      fullPath: '/online-store/menus'
      preLoaderRoute: typeof StoreOnlineStoreMenusRouteImport
      parentRoute: typeof StoreRoute
    }
    '/_store/online-store/pages': {
      id: '/_store/online-store/pages'
      path: '/online-store/pages'
      fullPath: '/online-store/pages'
      preLoaderRoute: typeof StoreOnlineStorePagesRouteImport
      parentRoute: typeof StoreRoute
    }
    '/_store/online-store/theme': {
      id: '/_store/online-store/theme'
      path: '/online-store/theme'
      fullPath: '/online-store/theme'
      preLoaderRoute: typeof StoreOnlineStoreThemeRouteImport
      parentRoute: typeof StoreRoute
    }
    '/_store/online-store/theme-library': {
      id: '/_store/online-store/theme-library'
      path: '/online-store/theme-library'
      fullPath: '/online-store/theme-library'
      preLoaderRoute: typeof StoreOnlineStoreThemeLibraryRouteImport
      parentRoute: typeof StoreRoute
    }
    '/_store/orders_/$orderId': {
      id: '/_store/orders_/$orderId'
      path: '/orders/$orderId'
      fullPath: '/orders/$orderId'
      preLoaderRoute: typeof StoreOrdersOrderIdRouteImport
      parentRoute: typeof StoreRoute
    }
    '/_store/orders_/new': {
      id: '/_store/orders_/new'
      path: '/orders/new'
      fullPath: '/orders/new'
      preLoaderRoute: typeof StoreOrdersNewRouteImport
      parentRoute: typeof StoreRoute
    }
    '/_store/products/': {
      id: '/_store/products/'
      path: '/products'
      fullPath: '/products/'
      preLoaderRoute: typeof StoreProductsIndexRouteImport
      parentRoute: typeof StoreRoute
    }
    '/_store/products/$id': {
      id: '/_store/products/$id'
      path: '/products/$id'
      fullPath: '/products/$id'
      preLoaderRoute: typeof StoreProductsIdRouteImport
      parentRoute: typeof StoreRoute
    }
    '/_store/products/bulk-edit': {
      id: '/_store/products/bulk-edit'
      path: '/products/bulk-edit'
      fullPath: '/products/bulk-edit'
      preLoaderRoute: typeof StoreProductsBulkEditRouteImport
      parentRoute: typeof StoreRoute
    }
    '/_store/products/new': {
      id: '/_store/products/new'
      path: '/products/new'
      fullPath: '/products/new'
      preLoaderRoute: typeof StoreProductsNewRouteImport
      parentRoute: typeof StoreRoute
    }
    '/_store/returns_/$returnId': {
      id: '/_store/returns_/$returnId'
      path: '/returns/$returnId'
      fullPath: '/returns/$returnId'
      preLoaderRoute: typeof StoreReturnsReturnIdRouteImport
      parentRoute: typeof StoreRoute
    }
    '/_store/segments_/$segmentId': {
      id: '/_store/segments_/$segmentId'
      path: '/segments/$segmentId'
      fullPath: '/segments/$segmentId'
      preLoaderRoute: typeof StoreSegmentsSegmentIdRouteImport
      parentRoute: typeof StoreRoute
    }
    '/_store/segments_/new': {
      id: '/_store/segments_/new'
      path: '/segments/new'
      fullPath: '/segments/new'
      preLoaderRoute: typeof StoreSegmentsNewRouteImport
      parentRoute: typeof StoreRoute
    }
    '/_store/settings/': {
      id: '/_store/settings/'
      path: '/'
      fullPath: '/settings/'
      preLoaderRoute: typeof StoreSettingsIndexRouteImport
      parentRoute: typeof StoreSettingsRoute
    }
    '/_store/settings/activity': {
      id: '/_store/settings/activity'
      path: '/activity'
      fullPath: '/settings/activity'
      preLoaderRoute: typeof StoreSettingsActivityRouteImport
      parentRoute: typeof StoreSettingsRoute
    }
    '/_store/settings/apps': {
      id: '/_store/settings/apps'
      path: '/apps'
      fullPath: '/settings/apps'
      preLoaderRoute: typeof StoreSettingsAppsRouteImport
      parentRoute: typeof StoreSettingsRoute
    }
    '/_store/settings/branding': {
      id: '/_store/settings/branding'
      path: '/branding'
      fullPath: '/settings/branding'
      preLoaderRoute: typeof StoreSettingsBrandingRouteImport
      parentRoute: typeof StoreSettingsRoute
    }
    '/_store/settings/checkout': {
      id: '/_store/settings/checkout'
      path: '/checkout'
      fullPath: '/settings/checkout'
      preLoaderRoute: typeof StoreSettingsCheckoutRouteImport
      parentRoute: typeof StoreSettingsRoute
    }
    '/_store/settings/custom-fields': {
      id: '/_store/settings/custom-fields'
      path: '/custom-fields'
      fullPath: '/settings/custom-fields'
      preLoaderRoute: typeof StoreSettingsCustomFieldsRouteImport
      parentRoute: typeof StoreSettingsRoute
    }
    '/_store/settings/customer-accounts': {
      id: '/_store/settings/customer-accounts'
      path: '/customer-accounts'
      fullPath: '/settings/customer-accounts'
      preLoaderRoute: typeof StoreSettingsCustomerAccountsRouteImport
      parentRoute: typeof StoreSettingsRoute
    }
    '/_store/settings/customer-privacy': {
      id: '/_store/settings/customer-privacy'
      path: '/customer-privacy'
      fullPath: '/settings/customer-privacy'
      preLoaderRoute: typeof StoreSettingsCustomerPrivacyRouteImport
      parentRoute: typeof StoreSettingsRoute
    }
    '/_store/settings/domains': {
      id: '/_store/settings/domains'
      path: '/domains'
      fullPath: '/settings/domains'
      preLoaderRoute: typeof StoreSettingsDomainsRouteImport
      parentRoute: typeof StoreSettingsRoute
    }
    '/_store/settings/email-branding': {
      id: '/_store/settings/email-branding'
      path: '/email-branding'
      fullPath: '/settings/email-branding'
      preLoaderRoute: typeof StoreSettingsEmailBrandingRouteImport
      parentRoute: typeof StoreSettingsRoute
    }
    '/_store/settings/markets': {
      id: '/_store/settings/markets'
      path: '/markets'
      fullPath: '/settings/markets'
      preLoaderRoute: typeof StoreSettingsMarketsRouteImport
      parentRoute: typeof StoreSettingsRoute
    }
    '/_store/settings/notification-alerts': {
      id: '/_store/settings/notification-alerts'
      path: '/notification-alerts'
      fullPath: '/settings/notification-alerts'
      preLoaderRoute: typeof StoreSettingsNotificationAlertsRouteImport
      parentRoute: typeof StoreSettingsRoute
    }
    '/_store/settings/notifications': {
      id: '/_store/settings/notifications'
      path: '/notifications'
      fullPath: '/settings/notifications'
      preLoaderRoute: typeof StoreSettingsNotificationsRouteImport
      parentRoute: typeof StoreSettingsRoute
    }
    '/_store/settings/orders': {
      id: '/_store/settings/orders'
      path: '/orders'
      fullPath: '/settings/orders'
      preLoaderRoute: typeof StoreSettingsOrdersRouteImport
      parentRoute: typeof StoreSettingsRoute
    }
    '/_store/settings/payments': {
      id: '/_store/settings/payments'
      path: '/payments'
      fullPath: '/settings/payments'
      preLoaderRoute: typeof StoreSettingsPaymentsRouteImport
      parentRoute: typeof StoreSettingsRoute
    }
    '/_store/settings/plan-and-billing': {
      id: '/_store/settings/plan-and-billing'
      path: '/plan-and-billing'
      fullPath: '/settings/plan-and-billing'
      preLoaderRoute: typeof StoreSettingsPlanAndBillingRouteImport
      parentRoute: typeof StoreSettingsRoute
    }
    '/_store/settings/policies': {
      id: '/_store/settings/policies'
      path: '/policies'
      fullPath: '/settings/policies'
      preLoaderRoute: typeof StoreSettingsPoliciesRouteImport
      parentRoute: typeof StoreSettingsRoute
    }
    '/_store/settings/returns': {
      id: '/_store/settings/returns'
      path: '/returns'
      fullPath: '/settings/returns'
      preLoaderRoute: typeof StoreSettingsReturnsRouteImport
      parentRoute: typeof StoreSettingsRoute
    }
    '/_store/settings/shipping': {
      id: '/_store/settings/shipping'
      path: '/shipping'
      fullPath: '/settings/shipping'
      preLoaderRoute: typeof StoreSettingsShippingRouteImport
      parentRoute: typeof StoreSettingsRoute
    }
    '/_store/settings/storage': {
      id: '/_store/settings/storage'
      path: '/storage'
      fullPath: '/settings/storage'
      preLoaderRoute: typeof StoreSettingsStorageRouteImport
      parentRoute: typeof StoreSettingsRoute
    }
    '/_store/settings/store-details': {
      id: '/_store/settings/store-details'
      path: '/store-details'
      fullPath: '/settings/store-details'
      preLoaderRoute: typeof StoreSettingsStoreDetailsRouteImport
      parentRoute: typeof StoreSettingsRoute
    }
    '/_store/settings/storefront': {
      id: '/_store/settings/storefront'
      path: '/storefront'
      fullPath: '/settings/storefront'
      preLoaderRoute: typeof StoreSettingsStorefrontRouteImport
      parentRoute: typeof StoreSettingsRoute
    }
    '/_store/settings/support': {
      id: '/_store/settings/support'
      path: '/support'
      fullPath: '/settings/support'
      preLoaderRoute: typeof StoreSettingsSupportRouteImport
      parentRoute: typeof StoreSettingsRoute
    }
    '/_store/settings/taxes': {
      id: '/_store/settings/taxes'
      path: '/taxes'
      fullPath: '/settings/taxes'
      preLoaderRoute: typeof StoreSettingsTaxesRouteImport
      parentRoute: typeof StoreSettingsRoute
    }
    '/_store/settings/team': {
      id: '/_store/settings/team'
      path: '/team'
      fullPath: '/settings/team'
      preLoaderRoute: typeof StoreSettingsTeamRouteImport
      parentRoute: typeof StoreSettingsRoute
    }
    '/_store/settings/users': {
      id: '/_store/settings/users'
      path: '/users'
      fullPath: '/settings/users'
      preLoaderRoute: typeof StoreSettingsUsersRouteImport
      parentRoute: typeof StoreSettingsRoute
    }
    '/_editor/online-store/editor/$pageId': {
      id: '/_editor/online-store/editor/$pageId'
      path: '/online-store/editor/$pageId'
      fullPath: '/online-store/editor/$pageId'
      preLoaderRoute: typeof EditorOnlineStoreEditorPageIdRouteImport
      parentRoute: typeof EditorRoute
    }
    '/_store/online-store/blog_/$id': {
      id: '/_store/online-store/blog_/$id'
      path: '/online-store/blog/$id'
      fullPath: '/online-store/blog/$id'
      preLoaderRoute: typeof StoreOnlineStoreBlogIdRouteImport
      parentRoute: typeof StoreRoute
    }
    '/_store/online-store/blog_/categories': {
      id: '/_store/online-store/blog_/categories'
      path: '/online-store/blog/categories'
      fullPath: '/online-store/blog/categories'
      preLoaderRoute: typeof StoreOnlineStoreBlogCategoriesRouteImport
      parentRoute: typeof StoreRoute
    }
    '/_store/online-store/blog_/new': {
      id: '/_store/online-store/blog_/new'
      path: '/online-store/blog/new'
      fullPath: '/online-store/blog/new'
      preLoaderRoute: typeof StoreOnlineStoreBlogNewRouteImport
      parentRoute: typeof StoreRoute
    }
    '/_store/online-store/menus_/$handle': {
      id: '/_store/online-store/menus_/$handle'
      path: '/online-store/menus/$handle'
      fullPath: '/online-store/menus/$handle'
      preLoaderRoute: typeof StoreOnlineStoreMenusHandleRouteImport
      parentRoute: typeof StoreRoute
    }
    '/_store/settings/markets_/$id': {
      id: '/_store/settings/markets_/$id'
      path: '/markets/$id'
      fullPath: '/settings/markets/$id'
      preLoaderRoute: typeof StoreSettingsMarketsIdRouteImport
      parentRoute: typeof StoreSettingsRoute
    }
  }
}

interface EditorRouteChildren {
  EditorOnlineStoreThemeSettingsRoute: typeof EditorOnlineStoreThemeSettingsRoute
  EditorOnlineStoreEditorPageIdRoute: typeof EditorOnlineStoreEditorPageIdRoute
}

const EditorRouteChildren: EditorRouteChildren = {
  EditorOnlineStoreThemeSettingsRoute: EditorOnlineStoreThemeSettingsRoute,
  EditorOnlineStoreEditorPageIdRoute: EditorOnlineStoreEditorPageIdRoute,
}

const EditorRouteWithChildren =
  EditorRoute._addFileChildren(EditorRouteChildren)

interface StoreSettingsRouteChildren {
  StoreSettingsActivityRoute: typeof StoreSettingsActivityRoute
  StoreSettingsAppsRoute: typeof StoreSettingsAppsRoute
  StoreSettingsBrandingRoute: typeof StoreSettingsBrandingRoute
  StoreSettingsCheckoutRoute: typeof StoreSettingsCheckoutRoute
  StoreSettingsCustomFieldsRoute: typeof StoreSettingsCustomFieldsRoute
  StoreSettingsCustomerAccountsRoute: typeof StoreSettingsCustomerAccountsRoute
  StoreSettingsCustomerPrivacyRoute: typeof StoreSettingsCustomerPrivacyRoute
  StoreSettingsDomainsRoute: typeof StoreSettingsDomainsRoute
  StoreSettingsEmailBrandingRoute: typeof StoreSettingsEmailBrandingRoute
  StoreSettingsMarketsRoute: typeof StoreSettingsMarketsRoute
  StoreSettingsNotificationAlertsRoute: typeof StoreSettingsNotificationAlertsRoute
  StoreSettingsNotificationsRoute: typeof StoreSettingsNotificationsRoute
  StoreSettingsOrdersRoute: typeof StoreSettingsOrdersRoute
  StoreSettingsPaymentsRoute: typeof StoreSettingsPaymentsRoute
  StoreSettingsPlanAndBillingRoute: typeof StoreSettingsPlanAndBillingRoute
  StoreSettingsPoliciesRoute: typeof StoreSettingsPoliciesRoute
  StoreSettingsReturnsRoute: typeof StoreSettingsReturnsRoute
  StoreSettingsShippingRoute: typeof StoreSettingsShippingRoute
  StoreSettingsStorageRoute: typeof StoreSettingsStorageRoute
  StoreSettingsStoreDetailsRoute: typeof StoreSettingsStoreDetailsRoute
  StoreSettingsStorefrontRoute: typeof StoreSettingsStorefrontRoute
  StoreSettingsSupportRoute: typeof StoreSettingsSupportRoute
  StoreSettingsTaxesRoute: typeof StoreSettingsTaxesRoute
  StoreSettingsTeamRoute: typeof StoreSettingsTeamRoute
  StoreSettingsUsersRoute: typeof StoreSettingsUsersRoute
  StoreSettingsIndexRoute: typeof StoreSettingsIndexRoute
  StoreSettingsMarketsIdRoute: typeof StoreSettingsMarketsIdRoute
}

const StoreSettingsRouteChildren: StoreSettingsRouteChildren = {
  StoreSettingsActivityRoute: StoreSettingsActivityRoute,
  StoreSettingsAppsRoute: StoreSettingsAppsRoute,
  StoreSettingsBrandingRoute: StoreSettingsBrandingRoute,
  StoreSettingsCheckoutRoute: StoreSettingsCheckoutRoute,
  StoreSettingsCustomFieldsRoute: StoreSettingsCustomFieldsRoute,
  StoreSettingsCustomerAccountsRoute: StoreSettingsCustomerAccountsRoute,
  StoreSettingsCustomerPrivacyRoute: StoreSettingsCustomerPrivacyRoute,
  StoreSettingsDomainsRoute: StoreSettingsDomainsRoute,
  StoreSettingsEmailBrandingRoute: StoreSettingsEmailBrandingRoute,
  StoreSettingsMarketsRoute: StoreSettingsMarketsRoute,
  StoreSettingsNotificationAlertsRoute: StoreSettingsNotificationAlertsRoute,
  StoreSettingsNotificationsRoute: StoreSettingsNotificationsRoute,
  StoreSettingsOrdersRoute: StoreSettingsOrdersRoute,
  StoreSettingsPaymentsRoute: StoreSettingsPaymentsRoute,
  StoreSettingsPlanAndBillingRoute: StoreSettingsPlanAndBillingRoute,
  StoreSettingsPoliciesRoute: StoreSettingsPoliciesRoute,
  StoreSettingsReturnsRoute: StoreSettingsReturnsRoute,
  StoreSettingsShippingRoute: StoreSettingsShippingRoute,
  StoreSettingsStorageRoute: StoreSettingsStorageRoute,
  StoreSettingsStoreDetailsRoute: StoreSettingsStoreDetailsRoute,
  StoreSettingsStorefrontRoute: StoreSettingsStorefrontRoute,
  StoreSettingsSupportRoute: StoreSettingsSupportRoute,
  StoreSettingsTaxesRoute: StoreSettingsTaxesRoute,
  StoreSettingsTeamRoute: StoreSettingsTeamRoute,
  StoreSettingsUsersRoute: StoreSettingsUsersRoute,
  StoreSettingsIndexRoute: StoreSettingsIndexRoute,
  StoreSettingsMarketsIdRoute: StoreSettingsMarketsIdRoute,
}

const StoreSettingsRouteWithChildren = StoreSettingsRoute._addFileChildren(
  StoreSettingsRouteChildren,
)

interface StoreRouteChildren {
  StoreAbandonedCheckoutsRoute: typeof StoreAbandonedCheckoutsRoute
  StoreBrandsRoute: typeof StoreBrandsRoute
  StoreCategoriesRoute: typeof StoreCategoriesRoute
  StoreCollectionsRoute: typeof StoreCollectionsRoute
  StoreCustomersRoute: typeof StoreCustomersRoute
  StoreDiscountsRoute: typeof StoreDiscountsRoute
  StoreFinanceRoute: typeof StoreFinanceRoute
  StoreFormSubmissionsRoute: typeof StoreFormSubmissionsRoute
  StoreLeadsRoute: typeof StoreLeadsRoute
  StoreLocationsRoute: typeof StoreLocationsRoute
  StoreOrdersRoute: typeof StoreOrdersRoute
  StorePreordersRoute: typeof StorePreordersRoute
  StoreQuotesRoute: typeof StoreQuotesRoute
  StoreReturnsRoute: typeof StoreReturnsRoute
  StoreReviewsRoute: typeof StoreReviewsRoute
  StoreSegmentsRoute: typeof StoreSegmentsRoute
  StoreSettingsRoute: typeof StoreSettingsRouteWithChildren
  StoreIndexRoute: typeof StoreIndexRoute
  StoreAppsStatePricingRoute: typeof StoreAppsStatePricingRoute
  StoreCategoriesIdRoute: typeof StoreCategoriesIdRoute
  StoreCategoriesBulkEditRoute: typeof StoreCategoriesBulkEditRoute
  StoreCategoriesNewRoute: typeof StoreCategoriesNewRoute
  StoreCollectionsIdRoute: typeof StoreCollectionsIdRoute
  StoreCollectionsBulkEditRoute: typeof StoreCollectionsBulkEditRoute
  StoreCollectionsNewRoute: typeof StoreCollectionsNewRoute
  StoreCustomersCustomerIdRoute: typeof StoreCustomersCustomerIdRoute
  StoreDiscountsIdRoute: typeof StoreDiscountsIdRoute
  StoreDiscountsNewRoute: typeof StoreDiscountsNewRoute
  StoreFinanceExpensesRoute: typeof StoreFinanceExpensesRoute
  StoreFinanceReportsRoute: typeof StoreFinanceReportsRoute
  StoreLocationsIdRoute: typeof StoreLocationsIdRoute
  StoreLocationsNewRoute: typeof StoreLocationsNewRoute
  StoreOnlineStoreBlogRoute: typeof StoreOnlineStoreBlogRoute
  StoreOnlineStoreMediaRoute: typeof StoreOnlineStoreMediaRoute
  StoreOnlineStoreMenusRoute: typeof StoreOnlineStoreMenusRoute
  StoreOnlineStorePagesRoute: typeof StoreOnlineStorePagesRoute
  StoreOnlineStoreThemeRoute: typeof StoreOnlineStoreThemeRoute
  StoreOnlineStoreThemeLibraryRoute: typeof StoreOnlineStoreThemeLibraryRoute
  StoreOrdersOrderIdRoute: typeof StoreOrdersOrderIdRoute
  StoreOrdersNewRoute: typeof StoreOrdersNewRoute
  StoreProductsIdRoute: typeof StoreProductsIdRoute
  StoreProductsBulkEditRoute: typeof StoreProductsBulkEditRoute
  StoreProductsNewRoute: typeof StoreProductsNewRoute
  StoreReturnsReturnIdRoute: typeof StoreReturnsReturnIdRoute
  StoreSegmentsSegmentIdRoute: typeof StoreSegmentsSegmentIdRoute
  StoreSegmentsNewRoute: typeof StoreSegmentsNewRoute
  StoreAppsIndexRoute: typeof StoreAppsIndexRoute
  StoreInventoryIndexRoute: typeof StoreInventoryIndexRoute
  StoreProductsIndexRoute: typeof StoreProductsIndexRoute
  StoreOnlineStoreBlogIdRoute: typeof StoreOnlineStoreBlogIdRoute
  StoreOnlineStoreBlogCategoriesRoute: typeof StoreOnlineStoreBlogCategoriesRoute
  StoreOnlineStoreBlogNewRoute: typeof StoreOnlineStoreBlogNewRoute
  StoreOnlineStoreMenusHandleRoute: typeof StoreOnlineStoreMenusHandleRoute
}

const StoreRouteChildren: StoreRouteChildren = {
  StoreAbandonedCheckoutsRoute: StoreAbandonedCheckoutsRoute,
  StoreBrandsRoute: StoreBrandsRoute,
  StoreCategoriesRoute: StoreCategoriesRoute,
  StoreCollectionsRoute: StoreCollectionsRoute,
  StoreCustomersRoute: StoreCustomersRoute,
  StoreDiscountsRoute: StoreDiscountsRoute,
  StoreFinanceRoute: StoreFinanceRoute,
  StoreFormSubmissionsRoute: StoreFormSubmissionsRoute,
  StoreLeadsRoute: StoreLeadsRoute,
  StoreLocationsRoute: StoreLocationsRoute,
  StoreOrdersRoute: StoreOrdersRoute,
  StorePreordersRoute: StorePreordersRoute,
  StoreQuotesRoute: StoreQuotesRoute,
  StoreReturnsRoute: StoreReturnsRoute,
  StoreReviewsRoute: StoreReviewsRoute,
  StoreSegmentsRoute: StoreSegmentsRoute,
  StoreSettingsRoute: StoreSettingsRouteWithChildren,
  StoreIndexRoute: StoreIndexRoute,
  StoreAppsStatePricingRoute: StoreAppsStatePricingRoute,
  StoreCategoriesIdRoute: StoreCategoriesIdRoute,
  StoreCategoriesBulkEditRoute: StoreCategoriesBulkEditRoute,
  StoreCategoriesNewRoute: StoreCategoriesNewRoute,
  StoreCollectionsIdRoute: StoreCollectionsIdRoute,
  StoreCollectionsBulkEditRoute: StoreCollectionsBulkEditRoute,
  StoreCollectionsNewRoute: StoreCollectionsNewRoute,
  StoreCustomersCustomerIdRoute: StoreCustomersCustomerIdRoute,
  StoreDiscountsIdRoute: StoreDiscountsIdRoute,
  StoreDiscountsNewRoute: StoreDiscountsNewRoute,
  StoreFinanceExpensesRoute: StoreFinanceExpensesRoute,
  StoreFinanceReportsRoute: StoreFinanceReportsRoute,
  StoreLocationsIdRoute: StoreLocationsIdRoute,
  StoreLocationsNewRoute: StoreLocationsNewRoute,
  StoreOnlineStoreBlogRoute: StoreOnlineStoreBlogRoute,
  StoreOnlineStoreMediaRoute: StoreOnlineStoreMediaRoute,
  StoreOnlineStoreMenusRoute: StoreOnlineStoreMenusRoute,
  StoreOnlineStorePagesRoute: StoreOnlineStorePagesRoute,
  StoreOnlineStoreThemeRoute: StoreOnlineStoreThemeRoute,
  StoreOnlineStoreThemeLibraryRoute: StoreOnlineStoreThemeLibraryRoute,
  StoreOrdersOrderIdRoute: StoreOrdersOrderIdRoute,
  StoreOrdersNewRoute: StoreOrdersNewRoute,
  StoreProductsIdRoute: StoreProductsIdRoute,
  StoreProductsBulkEditRoute: StoreProductsBulkEditRoute,
  StoreProductsNewRoute: StoreProductsNewRoute,
  StoreReturnsReturnIdRoute: StoreReturnsReturnIdRoute,
  StoreSegmentsSegmentIdRoute: StoreSegmentsSegmentIdRoute,
  StoreSegmentsNewRoute: StoreSegmentsNewRoute,
  StoreAppsIndexRoute: StoreAppsIndexRoute,
  StoreInventoryIndexRoute: StoreInventoryIndexRoute,
  StoreProductsIndexRoute: StoreProductsIndexRoute,
  StoreOnlineStoreBlogIdRoute: StoreOnlineStoreBlogIdRoute,
  StoreOnlineStoreBlogCategoriesRoute: StoreOnlineStoreBlogCategoriesRoute,
  StoreOnlineStoreBlogNewRoute: StoreOnlineStoreBlogNewRoute,
  StoreOnlineStoreMenusHandleRoute: StoreOnlineStoreMenusHandleRoute,
}

const StoreRouteWithChildren = StoreRoute._addFileChildren(StoreRouteChildren)

interface PlatformRouteChildren {
  PlatformIndexRoute: typeof PlatformIndexRoute
}

const PlatformRouteChildren: PlatformRouteChildren = {
  PlatformIndexRoute: PlatformIndexRoute,
}

const PlatformRouteWithChildren = PlatformRoute._addFileChildren(
  PlatformRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  EditorRoute: EditorRouteWithChildren,
  StoreRoute: StoreRouteWithChildren,
  AcceptInviteRoute: AcceptInviteRoute,
  ForgotPasswordRoute: ForgotPasswordRoute,
  LoginRoute: LoginRoute,
  PlatformRoute: PlatformRouteWithChildren,
  ResetPasswordRoute: ResetPasswordRoute,
  SupportRoute: SupportRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
